import { useTranslation } from 'react-i18next';
import { CONFIG } from '@frontend/config';
import { catalogAdminPath, useCatalogAdminCapability } from '@frontend/features/hotel-catalog-admin/queries';
import { HotelSearchPolicy } from '@frontend/features/hotel-search-policy/HotelSearchPolicy';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Paper, Typography } from '@mui/material';
import { HotelConnections } from '@frontend/features/hotels/HotelConnections';

export const AgencyHotelConnections = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const catalogAdmin = useCatalogAdminCapability();
  return (
    <Box sx={{ p: 3, width: '100%', overflowY: 'auto' }}>
      {catalogAdmin.data?.allowed && Number(id) === Number(CONFIG.AGENCY_ID) && (
        <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
          <Typography variant="h6">{t('hotelCatalogAdmin.title')}</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ my: 1 }}>
            {t('hotelDestinationOrder.agencyDescription')}
          </Typography>
          <Button variant="outlined" onClick={() => navigate(catalogAdminPath)}>
            {t('hotelDestinationOrder.title')}
          </Button>
        </Paper>
      )}
      <HotelConnections key={id} agencyId={Number(id)} />
      <HotelSearchPolicy key={`policy-${id}`} agencyId={Number(id)} />
    </Box>
  );
};
